import { render } from "./WarehouseDatatableTDNotify.vue?vue&type=template&id=148fcfc8"
import script from "./WarehouseDatatableTDNotify.vue?vue&type=script&lang=js"
export * from "./WarehouseDatatableTDNotify.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__